<template>
  <div class="w_contact mb_contact">
    <div class="w_container">
      <div class="index_tit fcolor">
        <h1 >与我们联系</h1>
        <p style="color: #c3bebe;">
          您若有建议或业务咨询的问题，可通过以下方式与我们取得联系
        </p>
      </div>
      <div class="w_contactus">
        <el-row>
            <el-col :xs="24" :span="12">
            <div class="grid-content bg-purple-light fcolor addreMar" style="text-align:center;">
              <el-form ref="form" :model="form"  >
                <el-form-item label="" >
                      <el-input v-model="form.userName"  placeholder="请输入姓名"></el-input>
                </el-form-item>
                 <el-form-item label="" >
                      <el-input v-model="form.phone"  placeholder="请输入电话"></el-input>
                </el-form-item>
                 <el-form-item label="" >
                      <el-input v-model="form.mail"  placeholder="请输入Email"></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input type="textarea" v-model="form.msg" placeholder="留言内容"></el-input>
                </el-form-item>
                <el-form-item label="">
   
                <verify-slider  @success="successHandler" style="width:auto;"></verify-slider>

                </el-form-item>
                <el-form-item>
                    <div style="width:70%;margin: 0 auto;"><el-button type="primary" @click="onSubmit" style="width:100%;">提交留言</el-button>
                    </div>                
                </el-form-item>
              </el-form>
            </div>
          </el-col>

          <el-col :xs="24" :span="12">
            <div class="grid-content bg-purple addre">
              <div class="met-editor">
                <div class="contact-text">
                  <p style="margin-bottom:20px;">
                    <strong class="company fcolor">江苏金赛德供应链管理有限公司</strong>
                  </p>
                  <p class="contact-text-item">
                    <i class="el-icon-location"></i> 地址：江苏昆山开发区景德路28号孚沃德科创园3号楼2楼
                  </p>
                  <p class="contact-text-item ">
                    <i class="el-icon-phone"></i> 电话：0512-57001598
                  </p>
                  <p class="contact-text-item">
                    <i class="el-icon-s-order"></i> 传真：0512-57001590
                  </p>
                  <p class="contact-text-item">
                    <i class="el-icon-tickets"></i> 邮编：215300<br>
                  </p>
                  <div class="contact-text-item" style="margin-top:20px;">
                     <p class="contact-text-item" > 关注微信公众号：</p>
                     <p><img src="../../assets/gzh.jpg" alt="" height="150"></p>
                  </div>
                </div>
                
              </div>
            </div>
          </el-col>
        
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  import $http from '../../util/fetch.js'
import { VerifySlider } from 'vue-verify-slider'
  export default {
    data() {
      return {
           form: {
            userName: '',
            phone: '',
            mail: '',
            msg: '',
            msgHudong:'',
            checkStatus:false  //判断滑动是否滑动到右边
          }
      }
    },
    components: {
      VerifySlider 
    },
     methods: {
      successHandler(){
         this.checkStatus =true
      },
        
      onSubmit() {
         var that =this
          let obj ={
            userName:that.form.userName,
            phone:that.form.phone,
            mail:that.form.mail,
            msg:that.form.msg
        }
      
         if(!that.form.phone){
           this.$message({
            message:'请填写联系电话',
             type: 'warning',
             customClass:'customType'
          });
           return;
       }
         
         
        if(!that.checkStatus){
            this.$message({
              message:'请滑动滑块验证！',
               type: 'warning',
               customClass:'customType'
            });
            return;
        }
        if(!/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/.test(that.form.phone)&&!/0\d{2,3}-\d{7,8}/.test(that.form.phone)){
              this.$message({
              message:'请填写正确的号码！',
               type: 'warning',
               customClass:'customType'
            });
            return;
        }
        $http.post("/msg/addMsg",obj).then(function(res){
            if(res.success){
              that.$alert('留言提交成功,稍后有专人联系您！', '温馨提示', {
              confirmButtonText: '确定',
              callback: action => {
                location.reload()
              }
            });
          }
        })
        
      }
    }
  }


</script>

<style scoped>
  @media screen and (max-width:768px) {
    .mb_contact .addreMar{
      margin-right: 0px;
    }
    .mb_contact .addre{
      margin-left: 0px;
     
    }
}
.customType{
  top: 50%;
  margin-top: -25px;
}
.addreMar{
  margin-right: 100px;
}
.addre{
  margin-left: 100px;
}
.index_tit h1{
    font-size: 33px;
}
 .w_contact .el-form label{
    color: #e6d2d2;
   
}
  .w_contact {
    background-color: rgb(84, 92, 100);
    padding: 50px;
  }

  .index_tit {
    text-align: center;
    padding: 30px 0px;
  }

  .contact-text-item {
    color: #c3bebe;
    padding: 2px;
  }
.el-form-item .el-form-item__label{
    color: red;
}

</style>



// WEBPACK FOOTER //
// src/components/contact/contact.vue